import styled from 'styled-components';

export const Container = styled.span`
    display: flex;
    width: 100%;
    justify-content: center;
`;
